<template>
 <el-card class="red-widget pb-4 mix-blend-mode-multiple">
        <div v-if="$slots.header" slot="header">
            <slot name="header"></slot>
        </div>
        <div class="radial-guage-container text-center px-5" v-show="loaded">
            <radial-gauge :ref="gaugeRef" :value="value" :options="options" class="radial-guage-component w-100 h-auto"></radial-gauge>
        </div>
        <div class="row dash-avg-stats-container">
            <div class="col-md-8 offset-md-2">
              <div class="d-flex">
                <div class="card-body px-3 py-2 d-flex flex-column">
                  <div class="d-flex flex-row align-items-center">
                    <span class="card-value"><h2>${{ animatedAvgIncome }}</h2></span>
                    <span class="card-change"></span>
                  </div>
                  <small class="dashboard-stats-label">Average Net Commission ex GST</small>
                </div>
              </div>
            </div>
        </div>
 </el-card>
</template>

<script>
import RadialGauge from 'vue2-canvas-gauges/src/RadialGauge'
export default {
  components: {
    RadialGauge
  },
  props: {
    token: {
      type: String,
      required: true
    },
    dateScope: {
      type: Object,
      required: true
    },
    teamId: {
      type: [Number, String],
      required: false
    },
    brokerId: {
        type: Number,
        required: false
    },
  },
  data() {
    return {
      gaugeRef: "DashboardGauge",
      value: 0,
      loaded: false,
      options: {
        animateOnInit: false,
        animatedValue: false,
        fontNumbers: "Poppins",
        fontUnits: "Poppins",
        fontTitle: "Poppins",
        fontValue: "Poppins",
        fontValueSize: 13,
        fontNumbersSize: 13,
        fontNumbersWeight: "bold",
        fontUnitsSize: 13,
        title: "Ambition Cloud",
        fontTitleSize: 14,
        colorTitle: '#000',
        colorBarProgress: "rgba(50,200,50,.75)",
        barWidth: 10,
        barShadow: 5,
        ticksWidth: 6,
        ticksWidthMinor: 2,

        width: 600,
        height: 600,
        units: "",
        minValue: 0,
        startAngle: 90,
        ticksAngle: 180,
        valueBox: true,
        maxValue: 3000,
        minorTicks: 5,
        strokeTicks: true,
        highlightsWidth: 10,
        highlights: [
            {
                "from": 2500,
                "to": 3000,
                "color": "rgba(200, 50, 50, .75)"
            }
        ],
        colorPlate: "#fff",
        borderShadowWidth: 0,
        borders: false,
        needleType: "arrow",
        needleWidth: 2,
        needleCircleSize: 7,
        needleCircleOuter: true,
        needleCircleInner: true,
        animationDuration: 1500,
        animationRule: "linear"
      },
      metrics: {
        current_avg_income: 0,
        overall_avg_income: 0
      }
    }
  },
  mounted() {

    document.fonts && document.fonts.forEach(function(font) {
        font.loaded.then(function() {
            if (font.family.match(/Led/)) {
                document.gauges.forEach(function(gauge) {
                    gauge.update();
                });
            }
        });
    });

    this.refreshData();
  },
  created() {
    this.$bus.$on("refreshed-data", value => {
      this.refreshData();
    });
  },
  watch: {
    "value": function(newValue) {
      TweenLite.TweenLite.to(this.$data.metrics, 1.5, {
        current_avg_income: newValue
      });
    },
    dateScope: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    teamId: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    brokerId: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    }
  },
  computed: {
    animatedAvgIncome: function() {
      return this.metrics.current_avg_income.toFixed(0);
    },
  },
  methods: {
    refreshData() {
      this.getAvgIncome();
    },
    async getAvgIncome() {
      try {
        // this.loaded = false;
        let res = await axios.get(`/api/v2/avg-income`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            startDate: this.$moment(this.dateScope.startDate).format('YYYY-MM-DD'),
            endDate: this.$moment(this.dateScope.endDate).format('YYYY-MM-DD'),
						teamId: this.teamId,
            brokerId: this.brokerId
          }
        });

        this.loaded = true;

        if (res.data !== undefined) {

            let tempMax = res.data.longAvg * 1.2;
            let tempIncrement = parseFloat(Number(tempMax / 250 / 5).toFixed(1)) * 250;
            tempMax =  tempIncrement * 5;

            if (tempMax != this.options.maxValue) {
              this.options.maxValue = tempMax;
              this.options.highlights[0].from = res.data.longAvg;
              this.options.highlights[0].to = tempMax;
              this.options.majorTicks = [
                "$0",
                "$" + tempIncrement * 1,
                "$" + tempIncrement * 2,
                "$" + tempIncrement * 3,
                "$" + tempIncrement * 4,
                "$" + tempIncrement * 5,
              ];
              this.$refs.DashboardGauge.chart.options = Object.assign(this.$refs.DashboardGauge.chart.options, this.options);
              this.$refs.DashboardGauge.chart.update();
            }

            this.value = res.data.shortAvg;

        }

      } catch (err) {
        console.error(err);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .radial-guage-container {
        overflow: hidden;
        max-width: 450px;
        margin: 0 auto;
        .canvas-gauges.radial-guage-component {
            margin-bottom: calc(-40%);
        }
    }
    .dash-avg-stats-container {
        .card-body {
            text-align: center !important;
        }
        .card-value {
            margin-left: auto !important;
            margin-right: auto !important;
        }
    }
</style>

<style lang="scss">
    .dash-avg-stats-container {
        .card-body {
            text-align: center !important;
        }
        .card-value {
            margin-left: auto !important;
            margin-right: auto !important;
        }
    }
</style>
